'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import ErrorPage from '@campaign-manager/app/ui/react/features/error/ErrorPage';

export default function ErrorHandler({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report error to Sentry
    Sentry.captureException(error, {
      tags: { errorBoundary: 'app-error' },
      extra: { digest: error.digest },
    });

    // Also log to console for debugging
    console.error('App error:', error);
  }, [error]);

  return (
    <ErrorPage
      error={error}
      showReloadButton
    />
  );
}
